/* eslint-disable jira/filename-case */
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { HelpPanelProps, HelpPanel as HelpPanelType } from './index.tsx';

export const AsyncLazyHelpPanel: LazyComponent<(props: HelpPanelProps) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof HelpPanelType>(
		() =>
			import(/* webpackChunkName: "async-help-panel" */ './index.tsx').then(
				({ HelpPanel }) => HelpPanel,
			),
		{ ssr: false },
	);
